import { useTranslations } from "next-intl";
import { clsx } from "clsx";
import * as m from "motion/react-m";
import IconCall from "@ui/central-icons/icons/IconCall";
import IconCallCancelFilled from "@ui/central-icons/icons/IconCallCancelFilled";
import IconStop from "@ui/central-icons/icons/IconStop";

export function AgentCallButton({
  sessionIsActive,
  isTextMode,
  onToggle,
  className,
}: {
  sessionIsActive: boolean;
  isTextMode?: boolean;
  onToggle: () => void;
  className?: string;
}) {
  const t = useTranslations("ClientKeys.ConvAI");

  const showStopIcon = sessionIsActive && isTextMode;

  return (
    <m.button
      layout
      type='button'
      className={clsx(
        "tw-bg-white tw-text-black tw-rounded-full tw-size-12 tw-flex tw-items-center tw-justify-center tw-outline-none focus-visible:tw-outline-focus",
        className,
      )}
      style={{ boxShadow: "0 0 1px 0 rgb(0 0 0 / 0.4), 0 4px 4px rgb(0 0 0 / 0.04)" }}
      aria-label={sessionIsActive ? (showStopIcon ? t("stop") : t("end_call")) : t("start_call")}
      onClick={onToggle}
    >
      {showStopIcon ? (
        <IconStop className='tw-size-6 tw-fill-current [&>path]:tw-stroke-0' />
      ) : sessionIsActive ? (
        <IconCallCancelFilled className='tw-size-6' />
      ) : (
        <IconCall className='tw-size-6 tw-fill-current [&>path]:tw-stroke-0' />
      )}
    </m.button>
  );
}
